import { render, staticRenderFns } from "./FacetRelatedGrid.vue?vue&type=template&id=37adefa3&"
import script from "./FacetRelatedGrid.vue?vue&type=script&lang=js&"
export * from "./FacetRelatedGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports